import { IconBugTrackerArrow } from '@contrast-security-inc/design-system-foundations'
import { css } from '@emotion/css'
import React from 'react'
import {
  CurrentVersion,
  LibraryNameCellBase,
  TooltipContentBugTrackers
} from '../..'
import { Library } from '../../../../../helpers/ui-interfaces'
import { LibraryGridPanelID } from '../../../../../helpers/drilldown-ui-interfaces'
import { RestrictionIcon } from '../../../restriction-icon'
import { NameCellRowData } from '../../interfaces'
import { styles } from './styles'
import { Tooltip } from '@contrast-security-inc/design-system-popovers'
import { PillList } from '@contrast-security-inc/design-system-badges'

interface Props extends Omit<NameCellRowData, 'id'> {
  organizationID: string
  applicationId: string | undefined
  appLibraryStatusEnabled?: boolean
  rowActiveInPanel: boolean
  onClick?: (props?: any) => void
  libraryId?: Library['id']
  setSelectedPanelTabId: React.Dispatch<
    React.SetStateAction<LibraryGridPanelID>
  >
}

export const Content = ({
  organizationID,
  appLibraryStatusEnabled,
  rowActiveInPanel,
  name,
  hash,
  language,
  group,
  tags,
  bugTrackers,
  ossEnabled,
  policies,
  licenses,
  versions: { current },
  usage,
  applicationId,
  onClick,
  libraryId,
  setSelectedPanelTabId
}: Props) => {
  return (
    <div
      className={css`
        margin-left: 10px;
      `}
    >
      <div className={styles.TopRowCss}>
        <div
          className={
            rowActiveInPanel
              ? styles.nameContainerActiveInPanelCss
              : styles.nameContainerCss
          }
        >
          <LibraryNameCellBase
            organizationID={organizationID}
            hash={hash}
            group={group}
            ossEnabled={ossEnabled}
            licenses={licenses}
            policies={policies}
            name={name}
            language={language}
            versions={{
              current
            }}
            usage={usage}
            onClick={onClick}
            libraryId={libraryId}
            setSelectedPanelTabId={setSelectedPanelTabId}
          />
        </div>

        {!!bugTrackers.length && !appLibraryStatusEnabled && (
          <div className={styles.bugTrackersContainerCss}>
            <Tooltip
              interactive
              placement="bottom"
              body={<TooltipContentBugTrackers bugTrackers={bugTrackers} />}
            >
              <IconBugTrackerArrow
                size="sm"
                color="neutral60"
                testId="bug-tracker-arrow"
              />
            </Tooltip>
          </div>
        )}
        <RestrictionIcon
          policies={{ ...policies }}
          applicationId={applicationId}
          updateActiveRowID={onClick}
          libraryId={libraryId}
          setSelectedPanelTabId={setSelectedPanelTabId}
        />
        {Array.isArray(tags) && tags.length > 0 && (
          <div className={styles.tagsCss}>
            <PillList pills={tags} />
          </div>
        )}
      </div>
      <CurrentVersion
        version={current.version}
        releaseDate={current.releaseDate}
        language={language}
      />
    </div>
  )
}
